import { Container } from '@acies/core';

export default class IconTitleSectionBody extends Container {
	public constructor() {
		super();
		this.autoLayout = 'vertical';
		this.width = 'fill';
		this.height = 'fill';
	}
}
customElements.define('ac-icon-title-section-body', IconTitleSectionBody);
